// Chakra imports
import { Portal, Box, useDisclosure, useBreakpointValue } from '@chakra-ui/react';
import Footer from 'components/footer/FooterAdmin.js';
// Layout components
import Navbar from 'components/navbar/NavbarAdmin.js';
import Sidebar from 'components/sidebar/Sidebar.js';
import Profile from 'views/admin/profile';
import { SidebarContext } from 'contexts/SidebarContext';
import React, { useState } from 'react';
import { Navigate, Route, Routes, useParams, useNavigate, useLocation, Outlet } from 'react-router-dom';
import routes, {
   masterRoutes,
   itemRoutes,
   transportRoutes,
   otherRoutes,
   saleRoutes,
   purchaseRoutes,
   bankAndCashRoutes,
   reportRoutes,
   inventoryRoutes,
} from 'routes.js';
import ItemTabs from 'layouts/item';
import ReceiveTabs from 'layouts/receive';
import MastersTabs from 'views/admin/masters';
import TransportTabs from 'layouts/transport';
import DaybookTabs from 'layouts/daybook';
import OtherTabs from 'layouts/other';
import SalesTabs from 'layouts/sales';
import InventoryTabs from 'layouts/inventory';
import PurchaseTabs from 'layouts/purchase';
import PurchaseInvoiceTabs from 'layouts/purchase invoice';
import {
   DaybookProvider,
   BusinessTypeProvider,
   UserProvider,
   GlobalProvider,
   AccountProvider,
   ItemProvider,
} from '../../contexts';
import { daybookRoutes } from 'routes';
import { AiOutlineMenuFold, AiOutlineMenuUnfold } from 'react-icons/ai';
import IconSidebar from 'components/sidebar/IconSidebar';
import ManageDaybook from 'views/admin/sales/Pages/SalesInvoiceMaster/ManageDaybook';
import IssueTabs from 'layouts/issue';
import PurchaseReturnTabs from '../purchase Return';
import SalesInvoiceTabs from '../sales invoice';
import SalesReturnTabs from '../sales Return';
import { filterRoutes } from '../../utils/util';
import { useSelector } from 'react-redux';
import { useGlobal } from "../../contexts";

// Custom Chakra theme
export default function Dashboard(props) {
   const { ...rest } = props;
   // states and functions
   const [fixed] = useState(false);
   const [toggleSidebar, setToggleSidebar] = useState(false);
   const [isSidebarOpen, setIsSidebarOpen] = useState(false);

   const user = useSelector((state) => state.user?.profile);
   const { company } = useGlobal();
   const filterRoutesData = filterRoutes(routes, user?.packageData?.[0], company?.setting);

   const navigate = useNavigate();
   let params = useParams();
   const location = useLocation();
   // functions for changing the states from components
   const getRoute = () => {
      return window.location.pathname !== '/admin/full-screen-maps';
   };
   const getActiveRoute = (routes) => {
      let activeRoute = 'Default Brand Text';
      for (let i = 0; i < routes.length; i++) {
         if (routes[i].collapse) {
            let collapseActiveRoute = getActiveRoute(routes[i].items);
            if (collapseActiveRoute !== activeRoute) {
               return collapseActiveRoute;
            }
         } else if (routes[i].category) {
            let categoryActiveRoute = getActiveRoute(routes[i].items);
            if (categoryActiveRoute !== activeRoute) {
               return categoryActiveRoute;
            }
         } else if (routes[i].name === 'Masters' && params['*'].startsWith('masters/')) {
            return routes[i].name;
         } else if (routes[i].name === 'Sales' && params['*'].startsWith('sales/')) {
            return routes[i].name;
         } else if (routes[i].name === 'Purchase' && params['*'].startsWith('purchase/')) {
            return routes[i].name;
         } else {
            if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
               return routes[i].name;
            }
         }
      }
      return activeRoute;
   };
   const getActiveNavbar = (routes) => {
      let activeNavbar = false;
      for (let i = 0; i < routes.length; i++) {
         if (routes[i].collapse) {
            let collapseActiveNavbar = getActiveNavbar(routes[i].items);
            if (collapseActiveNavbar !== activeNavbar) {
               return collapseActiveNavbar;
            }
         } else if (routes[i].category) {
            let categoryActiveNavbar = getActiveNavbar(routes[i].items);
            if (categoryActiveNavbar !== activeNavbar) {
               return categoryActiveNavbar;
            }
         } else {
            if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
               return routes[i].secondary;
            }
         }
      }
      return activeNavbar;
   };
   const getActiveNavbarText = (routes) => {
      let activeNavbar = false;
      for (let i = 0; i < routes.length; i++) {
         if (routes[i].collapse) {
            let collapseActiveNavbar = getActiveNavbarText(routes[i].items);
            if (collapseActiveNavbar !== activeNavbar) {
               return collapseActiveNavbar;
            }
         } else if (routes[i].category) {
            let categoryActiveNavbar = getActiveNavbarText(routes[i].items);
            if (categoryActiveNavbar !== activeNavbar) {
               return categoryActiveNavbar;
            }
         } else {
            if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
               return routes[i].messageNavbar;
            }
         }
      }
      return activeNavbar;
   };

   const getRoutes = (routes, parentPath = '') => {
      return routes.map((route, key) => {
         const fullPath = route.path;

         if (route.layout === '/admin') {
            return <Route path={fullPath} element={route.component} key={key} />;
         }
         if (route.layout === '/masters') {
            return <Route path={fullPath} element={route.component} key={key} />;
         }
         if (route.layout === '/items') {
            return <Route path={fullPath} element={route.component} key={key} />;
         }
         if (route.layout === '/transport') {
            return <Route path={fullPath} element={route.component} key={key} />;
         }
         if (route.layout === '/daybook') {
            return <Route path={fullPath} element={route.component} key={key} />;
         }
         if (route.layout === '/other') {
            return <Route path={fullPath} element={route.component} key={key} />;
         }
         if (route.layout === '/sales') {
            return <Route path={fullPath} element={route.component} key={key} />;
         }
         if (route.layout === '/purchase') {
            return <Route path={fullPath} element={route.component} key={key} />;
         }
         if (route.layout === '/inventory') {
            return <Route path={fullPath} element={route.component} key={key} />;
         }
         if (route.layout === '/report') {
            return <Route path={fullPath} element={route.component} key={key} />;
         }
         if (route.collapse) {
            return getRoutes(route.items, fullPath); // Pass the current path as the parent path
         }
         return null;
      });
   };

   document.documentElement.dir = 'ltr';
   const { onOpen } = useDisclosure();
   document.documentElement.dir = 'ltr';

   const handleClick = (route) => {
      navigate(`/admin/masters/${route}`);
   };

   const handleItemClick = (route) => {
      if (route === '') {
         navigate(`/admin/masters/items`);
      } else {
         navigate(`/admin/masters/items/${route}`);
      }
   };

   const handleTransportClick = (route) => {
      if (route === '') {
         navigate(`/admin/masters/transport`);
      } else {
         navigate(`/admin/masters/transport/${route}`);
      }
      // if (route === '') navigate(`/admin/masters/transport`);
      // navigate(`/admin/masters/transport/${route}`);
   };

   const handleDaybookClick = (route) => {
      if (route === '') {
         navigate(`/admin/masters/daybook`);
      } else {
         navigate(`/admin/masters/daybook/${route}`);
      }
   };

   const handleOtherClick = (route) => {
      navigate(`/admin/masters/other/${route}`);
   };

   const handleSaleClick = (route) => {
      navigate(`/admin/sales/${route}`);
   };

   const handleSalesInvoiceClick = (route) => {
      navigate(`/admin/sales/${route}`);
   };

   const handleSalesReturnClick = (route) => {
      navigate(`/admin/sales/${route}`);
   };

   const handlePurchaseClick = (route) => {
      navigate(`/admin/purchase/${route}`);
   };

   const handlePurchaseInvoiceClick = (route) => {
      navigate(`/admin/purchase/${route}`);
   };

   const handlePurchaseReturnClick = (route) => {
      navigate(`/admin/purchase/${route}`);
   };

   const handleInventoryClick = (route) => {
      navigate(`/admin/inventory/${route}`);
   };

   const handleReceiveClick = (route) => {
      navigate(`/admin/inventory/receive/${route}`);
   };

   const handleIssueClick = (route) => {
      navigate(`/admin/inventory/issue/${route}`);
   };

   const handleCashClick = (route) => {
      navigate(`/admin/cash/${route}`);
   };

   const handleBankClick = (route) => {
      navigate(`/admin/bank/${route}`);
   };

   // Add a handler for sidebar toggle
   const handleSidebarToggle = (isOpen) => {
      setIsSidebarOpen(isOpen);
   };

   const width = isSidebarOpen ? { base: '100%', xl: 'calc(100% - 90px)' } : { base: '100%', xl: 'calc(100% - 240px)' };

   const maxWidth = isSidebarOpen
      ? { base: '100%', xl: 'calc(100% - 90px)' }
      : { base: '100%', xl: 'calc(100% - 240px)' };

   return (
      <Box>
         <UserProvider>
            <GlobalProvider>
               <Box>
                  <SidebarContext.Provider
                     value={{
                        toggleSidebar,
                        setToggleSidebar,
                        isSidebarOpen, // Add to context if needed
                        setIsSidebarOpen,
                     }}>
                     {/* {sidebarRoutes && <IconSidebar routes={routes}  isSidebarOpen={isSidebarOpen} />} */}
                     <Box
                        float="right"
                        minHeight="100vh"
                        height="100%"
                        overflow="auto"
                        position="relative"
                        maxHeight="100%"
                        w={width}
                        maxWidth={maxWidth}
                        // w={{ base: '100%', xl: 'calc( 100% - 290px )' }}
                        // maxWidth={{ base: '100%', xl: 'calc( 100% - 290px )' }}
                        // w={{ base: '100%', xl: 'calc( 100% - 100px )' }}
                        // maxWidth={{ base: '100%', xl: 'calc( 100% - 100px )' }}
                        transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
                        transitionDuration=" 0.30s, 0.30s, 0.30s, 0s"
                        transitionProperty="top, bottom, width"
                        transitionTimingFunction="linear, linear, ease"
                        overflowY="hidden">
                        {/* {//!location.pathname.startsWith('/admin/sales/invoice/edit/') &&
                // !location.pathname.startsWith('/admin/sales/return/edit/') &&
                // !location.pathname.startsWith('/admin/purchase/invoice/edit/') &&
                // !location.pathname.startsWith('/admin/purchase/return/edit/') &&
                ![
                  // '/admin/purchase/invoice/add',
                  // '/admin/purchase/return/add',
                  // '/admin/sales/invoice/add',
                  // '/admin/sales/return/add',
                ].includes(location.pathname) ? ( */}
                        <Portal>
                           <Box width="100%">
                              <Navbar
                                 onOpen={onOpen}
                                 logoText={'Horizon UI Dashboard PRO'}
                                 brandText={getActiveRoute(filterRoutesData)}
                                 secondary={getActiveNavbar(filterRoutesData)}
                                 message={getActiveNavbarText(filterRoutesData)}
                                 fixed={fixed}
                                 isSidebarOpen={isSidebarOpen}
                                 setIsSidebarOpen={setIsSidebarOpen}
                                 onSidebarToggle={handleSidebarToggle}
                                 {...rest}
                              />
                           </Box>
                        </Portal>
                        {/*  ) : null} */}

                        {getRoute() ? (
                           <Box
                              // mx="auto"
                              // p={{ base: '20px', md: '30px' }}
                              // pe="20px"
                              // // minH='100vh'
                              // minH="100vh"
                              // maxH="100vh"
                              // overflowY="hidden"
                              // pt="50px"
                              className="pl-5">
                              {params['*'].startsWith('masters/') ? <MastersTabs handleClick={handleClick} /> : null}

                              {params['*'].startsWith('masters/items') ? (
                                 <ItemTabs handleItemClick={handleItemClick} />
                              ) : null}

                              {params['*'].startsWith('masters/transport') ? (
                                 <TransportTabs handleTransportClick={handleTransportClick} />
                              ) : null}

                              {params['*'].startsWith('masters/daybook') ? (
                                 <DaybookTabs handleDaybookClick={handleDaybookClick} />
                              ) : null}

                              {params['*'].startsWith('masters/other') ? (
                                 <OtherTabs handleOtherClick={handleOtherClick} />
                              ) : null}

                              {/* {params['*'].startsWith('sales/challan') ? (
                  <SalesTabs handleSaleClick={handleSaleClick} />
                ) : null} */}
                              {params['*'].startsWith('sales/') &&
                                 !params['*'].startsWith('sales/invoice/add') &&
                                 !params['*'].startsWith('sales/invoice/edit') &&
                                 !params['*'].startsWith('sales/return/add') &&
                                 !params['*'].startsWith('sales/invoice/managedaybook') &&
                                 !params['*'].startsWith('sales/return/managedaybook') &&
                                 !params['*'].startsWith('sales/challan/managedaybook') &&
                                 !params['*'].startsWith('sales/return/edit') &&
                                 !params['*'].startsWith('sales/challan/add') &&
                                 !params['*'].startsWith('sales/challan/edit') &&
                                 (user?.packageData?.[0]?.sales_invoice || user?.packageData?.[0]?.sales_return) ? (
                                 <SalesTabs handleSaleClick={handleSaleClick} />
                              ) : null}

                              {params['*'].startsWith('sales/invoice') &&
                                 !params['*'].startsWith('sales/invoice/managedaybook') &&
                                 !params['*'].startsWith('sales/invoice/add') &&
                                 !params['*'].startsWith('sales/invoice/edit') &&
                                 user?.packageData?.[0]?.sales_invoice ? (
                                 <SalesInvoiceTabs handleSalesInvoiceClick={handleSalesInvoiceClick} />
                              ) : null}

                              {params['*'].startsWith('sales/return') &&
                                 !params['*'].startsWith('sales/return/managedaybook') &&
                                 !params['*'].startsWith('sales/return/add') &&
                                 !params['*'].startsWith('sales/return/edit') &&
                                 user?.packageData?.[0]?.sales_return ? (
                                 <SalesReturnTabs handleSalesReturnClick={handleSalesReturnClick} />
                              ) : null}

                              {params['*'].startsWith('purchase/') &&
                                 !params['*'].startsWith('purchase/invoice/managedaybook') &&
                                 !params['*'].startsWith('purchase/return/managedaybook') &&
                                 !params['*'].startsWith('purchase/challan/managedaybook') &&
                                 !params['*'].startsWith('purchase/invoice/add') &&
                                 !params['*'].startsWith('purchase/invoice/edit') &&
                                 !params['*'].startsWith('purchase/return/add') &&
                                 !params['*'].startsWith('purchase/return/edit') &&
                                 !params['*'].startsWith('purchase/challan/add') &&
                                 !params['*'].startsWith('purchase/challan/edit') &&
                                 (user?.packageData?.[0]?.purchase_invoice || user?.packageData?.[0]?.purchase_return) ? (
                                 <PurchaseTabs handlePurchaseClick={handlePurchaseClick} />
                              ) : null}

                              {params['*'].startsWith('purchase/invoice') &&
                                 !params['*'].startsWith('purchase/invoice/managedaybook') &&
                                 !params['*'].startsWith('purchase/invoice/add') &&
                                 !params['*'].startsWith('purchase/invoice/edit') &&
                                 user?.packageData?.[0]?.purchase_invoice ? (
                                 <PurchaseInvoiceTabs handlePurchaseInvoiceClick={handlePurchaseInvoiceClick} />
                              ) : null}

                              {params['*'].startsWith('purchase/return') &&
                                 !params['*'].startsWith('purchase/return/managedaybook') &&
                                 !params['*'].startsWith('purchase/return/add') &&
                                 !params['*'].startsWith('purchase/return/edit') &&
                                 user?.packageData?.[0]?.purchase_return ? (
                                 <PurchaseReturnTabs handlePurchaseReturnClick={handlePurchaseReturnClick} />
                              ) : null}

                              {params['*'].startsWith('inventory/') &&
                                 !params['*'].startsWith('inventory/issue/managedaybook') &&
                                 !params['*'].startsWith('inventory/receive/managedaybook') &&
                                 !params['*'].startsWith('inventory/issue/add') &&
                                 !params['*'].startsWith('inventory/issue/edit') &&
                                 !params['*'].startsWith('inventory/receive/add') &&
                                 !params['*'].startsWith('inventory/receive/edit') &&
                                 (user?.packageData?.[0]?.issue || user?.packageData?.[0]?.receive || user?.packageData?.[0]?.stock_transfer) ? (
                                 <InventoryTabs handleInventoryClick={handleInventoryClick} />
                              ) : null}

                              {params['*'].startsWith('inventory/issue') &&
                                 !params['*'].startsWith('inventory/issue/managedaybook') &&
                                 !params['*'].startsWith('inventory/issue/add') &&
                                 !params['*'].startsWith('inventory/issue/edit') &&
                                 user?.packageData?.[0]?.issue ? (
                                 <IssueTabs handleInventoryClick={handleIssueClick} />
                              ) : null}

                              {params['*'].startsWith('inventory/receive') &&
                                 !params['*'].startsWith('inventory/receive/managedaybook') &&
                                 !params['*'].startsWith('inventory/receive/add') &&
                                 !params['*'].startsWith('inventory/receive/edit') &&
                                 user?.packageData?.[0]?.receive ? (
                                 <ReceiveTabs handleInventoryClick={handleReceiveClick} />
                              ) : null}

                              {params['*'].startsWith('cash/') ? (
                                 <ManageDaybook handleCashClick={handleCashClick} />
                              ) : null}
                              {params['*'].startsWith('bank/') ? (
                                 <ManageDaybook handleBankClick={handleBankClick} />
                              ) : null}
                              <BusinessTypeProvider>
                                 <DaybookProvider>
                                    <AccountProvider>
                                       <ItemProvider>
                                          <Routes>
                                             {getRoutes(filterRoutesData)}
                                             {getRoutes(masterRoutes)}
                                             {getRoutes(itemRoutes)}
                                             {getRoutes(transportRoutes)}
                                             {getRoutes(daybookRoutes)}
                                             {getRoutes(otherRoutes)}
                                             {getRoutes(saleRoutes)}
                                             {getRoutes(purchaseRoutes)}
                                             {getRoutes(bankAndCashRoutes)}
                                             {getRoutes(inventoryRoutes)}
                                             {getRoutes(reportRoutes)}
                                             <Route path="/" element={<Navigate to="/admin/default" replace />} />
                                          </Routes>
                                       </ItemProvider>
                                    </AccountProvider>
                                 </DaybookProvider>
                              </BusinessTypeProvider>
                              <Outlet />
                           </Box>
                        ) : null}
                        <Box>{/* <Footer /> */}</Box>
                     </Box>
                  </SidebarContext.Provider>
               </Box>
            </GlobalProvider>
         </UserProvider>
      </Box>
   );
}
